/* Update the pack quantity and its gifts together. Shrine's independent gift
   callbacks otherwise race against lines and keys changed by Shopify discounts. */
(() => {
  const normalizeProperties = value => JSON.stringify(Object.fromEntries(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b))));
  const identityOf = item => `${item.variant_id}|${normalizeProperties(item.properties)}|${item.selling_plan_allocation?.selling_plan?.id || ''}`;
  const rowIdentity = row => {
    const value = row?.dataset.itemIdentity;
    if (!value) return null;
    const first = value.indexOf('|'), last = value.lastIndexOf('|');
    return `${value.slice(0, first)}|${normalizeProperties(JSON.parse(value.slice(first + 1, last)))}|${value.slice(last + 1)}`;
  };
  const install = () => {
    const CartItems = customElements.get('cart-items');
    const configElement = document.getElementById('LirosiaBundleGifts');
    if (!CartItems || !configElement || CartItems.prototype.lirosiaQueueInstalled) return;
    const config = JSON.parse(configElement.textContent);
    let queue = Promise.resolve();
    const enqueue = task => {
      const result = queue.then(task);
      queue = result.catch(() => {});
      return result;
    };
    const packQuantity = cart => cart.items.filter(item => item.product_id === config.mainProductId)
      .reduce((total, item) => total + item.quantity, 0);
    const giftUpdates = (cart, quantity, gifts = config.gifts) => {
      const updates = {};
      for (const gift of gifts) {
        const ids = gift.variantIds || [gift.variantId];
        const existing = cart.items.filter(item => ids.includes(item.variant_id));
        const eligible = quantity >= gift.minimumQuantity;
        let retained = false;
        for (const item of existing) {
          const keep = eligible && !retained && item.variant_id === gift.variantId;
          const nextQuantity = keep ? 1 : 0;
          if (keep) retained = true;
          if (item.quantity !== nextQuantity) updates[item.key] = nextQuantity;
        }
        if (eligible && !retained && gift.variantId) updates[gift.variantId] = 1;
      }
      return updates;
    };
    const renderersForCart = () => {
      const renderers = [];
      for (const container of document.querySelectorAll('cart-items, cart-drawer-items')) {
        for (const section of container.getSectionsToRender()) {
          if (!renderers.some(entry => entry.section.id === section.id)) renderers.push({ container, section });
        }
      }
      return renderers;
    };
    const readCart = async () => {
      const response = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(window.cartStrings.error);
      return response.json();
    };
    const synchronizeEbook = () => enqueue(async () => {
      const cart = await readCart();
      const ebook = config.gifts.find(gift => gift.productId === config.ebookProductId);
      if (!ebook) return cart;
      const quantity = packQuantity(cart);
      const updates = giftUpdates(cart, quantity, [ebook]);
      if (!Object.keys(updates).length) return cart;
      const renderers = renderersForCart();
      const response = await fetch(`${routes.cart_update_url.replace(/\.js$/, '')}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: [...new Set(renderers.map(entry => entry.section.section))], sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.errors) throw new Error(result.description || result.message || window.cartStrings.error);
      for (const { container, section } of renderers) {
        const html = result.sections?.[section.section];
        if (!html) throw new Error(window.cartStrings.error);
        const root = document.getElementById(section.id);
        if (root) (root.querySelector(section.selector) || root).innerHTML = container.getSectionInnerHTML(html, section.selector);
      }
      document.querySelectorAll('cart-items, cart-drawer-items, cart-drawer, #main-cart-footer')
        .forEach(element => element.classList.toggle('is-empty', result.item_count === 0));
      document.querySelector('cart-drawer')?.setHeaderCartIconAccessibility();
      for (const gifts of document.querySelectorAll('quantity-gifts, quantity-break-upsells')) gifts.unlockGifts(quantity, false);
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: result });
      return result;
    });
    const showError = error => {
      const element = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (element) element.textContent = error.message || window.cartStrings.error;
      console.error('E-book language synchronization failed', error);
    };
    window.LirosiaEbookDelivery = { synchronize: synchronizeEbook };
    let checkoutInProgress = false;
    let allowCheckout = false;
    const continueCheckout = async control => {
      if (checkoutInProgress) return;
      checkoutInProgress = true;
      try {
        await synchronizeEbook();
        if (control.tagName === 'A') window.location.assign(control.href);
        else if (control.form) {
          const currentControl = document.getElementById(control.id) || control;
          const form = currentControl.form;
          if (!form?.isConnected) {
            window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
            return;
          }
          allowCheckout = true;
          form.requestSubmit(currentControl);
        } else window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (error) {
        allowCheckout = false;
        showError(error);
      } finally {
        checkoutInProgress = false;
      }
    };
    document.addEventListener('click', event => {
      const control = event.target.closest?.('button[name="checkout"], input[name="checkout"], a[href]');
      if (!control || allowCheckout || control.disabled) return;
      if (control.tagName === 'A') {
        const url = new URL(control.href, window.location.href);
        if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      continueCheckout(control);
    }, true);
    document.addEventListener('submit', event => {
      if (allowCheckout) { allowCheckout = false; return; }
      if (event.submitter?.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      continueCheckout(event.submitter);
    }, true);
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source !== 'cart-items') synchronizeEbook().catch(showError);
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted) synchronizeEbook().catch(showError);
    });
    synchronizeEbook().catch(showError);

    CartItems.prototype.updateQuantity = function (line, quantity, name) {
      const row = this.querySelector(`#CartItem-${line}, #CartDrawer-Item-${line}`);
      const key = row?.dataset.key, identity = rowIdentity(row), tag = this.localName;
      if (!key) return Promise.resolve();
      const task = queue.then(async () => {
        let owner = document.querySelector(tag);
        const errorElement = () => document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        const currentRow = Array.from(owner?.querySelectorAll('.cart-item[data-key]') || [])
          .find(item => item.dataset.key === key || rowIdentity(item) === identity);
        if (!owner || !currentRow) return;
        const currentLine = currentRow.dataset.index || currentRow.id.replace(/^Cart(?:Drawer-)?Item-/, '');
        owner.enableLoading(currentLine);
        if (errorElement()) errorElement().textContent = '';
        try {
          const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error(window.cartStrings.error);
          const cart = await cartResponse.json();
          const item = cart.items.find(item => item.key === key) || cart.items.find(item => identityOf(item) === identity);
          if (!item) return;
          const updates = { [item.key]: Number(quantity) };
          const mainQuantity = cart.items.filter(item => item.product_id === config.mainProductId)
            .reduce((total, current) => total + (current.key === item.key ? Number(quantity) : current.quantity), 0);
          Object.assign(updates, giftUpdates(cart, mainQuantity));
          const renderers = [];
          for (const container of document.querySelectorAll('cart-items, cart-drawer-items')) {
            for (const section of container.getSectionsToRender()) {
              if (!renderers.some(entry => entry.section.id === section.id)) renderers.push({ container, section });
            }
          }
          const response = await fetch(`${routes.cart_update_url.replace(/\.js$/, '')}.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, sections: [...new Set(renderers.map(entry => entry.section.section))], sections_url: window.location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.errors) throw new Error(result.description || result.message || window.cartStrings.error);
          for (const { container, section } of renderers) {
            const html = result.sections?.[section.section];
            if (!html) { window.location.reload(); return; }
            const root = document.getElementById(section.id);
            if (!root) continue;
            const target = root.querySelector(section.selector) || root;
            target.innerHTML = container.getSectionInnerHTML(html, section.selector);
          }
          document.querySelectorAll('cart-items, cart-drawer-items, cart-drawer, #main-cart-footer')
            .forEach(element => element.classList.toggle('is-empty', result.item_count === 0));
          owner = document.querySelector(tag);
          if (owner) owner.updateLiveRegions(currentLine, '');
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.setHeaderCartIconAccessibility();
          for (const gifts of document.querySelectorAll('quantity-gifts, quantity-break-upsells')) gifts.unlockGifts(mainQuantity, false);
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: result });
          const updatedRow = Array.from(owner?.querySelectorAll('.cart-item[data-key]') || [])
            .find(item => rowIdentity(item) === identity);
          const input = updatedRow?.querySelector('input[name="updates[]"]');
          const updatedItem = result.items.find(item => identityOf(item) === identity);
          if (updatedItem && updatedItem.quantity !== Number(quantity) && owner) {
            owner.updateLiveRegions(updatedRow?.dataset.index || currentLine, window.cartStrings.quantityError.replace('[quantity]', updatedItem.quantity));
          }
          if (input && name) input.focus();
          else if (result.item_count === 0 && drawer && drawer.classList.contains('active') && typeof trapFocus === 'function') {
            const empty = drawer.querySelector('.drawer__inner-empty');
            if (empty) trapFocus(empty, empty.querySelector('a'));
          }
        } catch (error) {
          if (errorElement()) errorElement().textContent = error.message || window.cartStrings.error;
        } finally {
          const currentOwner = document.querySelector(tag);
          if (currentOwner) currentOwner.disableLoading(currentLine);
        }
      });
      queue = task.catch(() => {});
      return task;
    };
    CartItems.prototype.lirosiaQueueInstalled = true;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();
